import { getContractLabel } from "@/utils/bookings";

export const contractFilter = value => {
  return getContractLabel(value);
};
